const ProductDetailsInfo = ({ product }) => {
  return (
    <section className="
      mt-10
      bg-white
      rounded-3xl
      border
      border-gray-200
      p-6
      lg:p-10
    ">

      {/* Description */}

      <div>

        <h2 className="
          text-2xl
          font-bold
          text-gray-900
        ">
          Product Description
        </h2>


        <p className="
          mt-5
          text-gray-600
          leading-relaxed
        ">
          {product.description}
        </p>

      </div>



      {/* Specifications */}

      <div className="
        mt-10
      ">

        <h2 className="
          text-2xl
          font-bold
          text-gray-900
        ">
          Specifications
        </h2>


        <div className="
          mt-5
          overflow-hidden
          rounded-2xl
          border
          border-gray-200
        ">

          {
            Object.entries(product.specifications || {}).map(
              ([key, value]) => (

                <div
                  key={key}
                  className="
                    grid
                    grid-cols-2
                    border-b
                    last:border-b-0
                    border-gray-200
                  "
                >

                  <div className="
                    px-5
                    py-4
                    bg-gray-50
                    font-medium
                    text-gray-700
                  ">
                    {key}
                  </div>


                  <div className="
                    px-5
                    py-4
                    text-gray-600
                  ">
                    {value}
                  </div>


                </div>

              )
            )
          }

        </div>


      </div>


    </section>
  );
};


export default ProductDetailsInfo;